export const projectConnectionsRoutes = {
  list: "",
  create: "new",
  edit: ":id/edit",
  listGroups: ":id/groups",
  createGroup: ":id/groups/new",
  editGroup: ":id/groups/:gid",
} as const;
